document.addEventListener('turbolinks:load', () => {
  // products

  $('.mega-menu__primary-item').hover(function () {
    $(this).find('.mega-menu__product-wrapper').addClass('active')
    $(this)
      .siblings('li')
      .find('.mega-menu__product-wrapper')
      .removeClass('active')
    $(this).find('.mega-menu__link--primary').addClass('active')
    $(this)
      .siblings('li')
      .find('.mega-menu__link--primary')
      .removeClass('active')
  })

  $( ".mega-menu__primary-item" ).first().hover(function () {
    $(this).find('.mega-menu__element-image').css( "display", "none")
  })


  $('.mega-menu__secondary-item').hover(function () {
    let category_id = $(this)[0].getAttribute('data-category-id');
    $(`#image_for_${category_id}`).attr('src', $(this)[0].getAttribute('data-img'));
  })

  $('.mega-menu__link--primary').hover(function () {
    let category_id = $(this)[0].getAttribute('data-category');
    $(`#image_for_${category_id}`).attr('src', $(this)[0].getAttribute('data-img'));
  })

  $('.mega-menu').on('mouseleave', function () {
    $(this).find('.mega-menu__product-wrapper').removeClass('active')
    $(this).find('.mega-menu__link--primary').removeClass('active')
    $('.mega-menu').hide()
    clearTimeout(timer);
  })

  $('.bottom-bar__dropdown-link').on('mouseenter', function () {
    timer = setTimeout(function(){
      $('.mega-menu').show()
    },350/* <--- the delay */)

    let id = $(this).data('target')
    let element = $('.mega-menu__link--' + id)
    element.addClass('active')
    element.parent().siblings().find('.mega-menu__link--primary').removeClass('active')

    let dropdown = $('.mega-menu__product-wrapper--' + id)
    dropdown.addClass('active')
    dropdown.parent().siblings().find('.mega-menu__product-wrapper').removeClass('active')
  })
  
  $('.bottom-bar__dropdown-link').on('mouseleave', function () {
    if($('.mega-menu').css('display') == 'block' && !$('.mega-menu').is(":hover")){
      $('.mega-menu').hide()
    }
    clearTimeout(timer);
  })
})
